import { useCallback } from 'react';
import { validateAuthorityLink } from '../utils';

// Hook for validating authority links
export const useAuthorityValidation = () => {
  // Validate authority link before applying
  const validateLink = useCallback((fieldPath, authorityRecord, formValues, fieldIndex) => {
    return validateAuthorityLink(fieldPath, authorityRecord, formValues, fieldIndex);
  }, []);

  // Check if linking is allowed
  const canLinkAuthority = useCallback((fieldPath, authorityRecord, formValues, fieldIndex) => {
    const validation = validateLink(fieldPath, authorityRecord, formValues, fieldIndex);
    return validation.isValid;
  }, [validateLink]);

  // Get validation error message
  const getValidationError = useCallback((fieldPath, authorityRecord, formValues, fieldIndex) => {
    const validation = validateLink(fieldPath, authorityRecord, formValues, fieldIndex);
    return validation.isValid ? null : validation.errorMessage;
  }, [validateLink]);

  return {
    validateLink,
    canLinkAuthority,
    getValidationError,
  };
};
